import { MemoId } from 'models/Memo';
import { createActor } from 'xstate';
import {
  ClosingBehaviour,
  editorMachine,
  EditorMode,
  EventType,
} from 'xstate/machines/EditorMachine';

export const EditorActor = createActor(editorMachine);
EditorActor.start();

export const reset = (): void => {
  EditorActor.send({ type: EventType.RequestReset });
};

export const closeEditor = (): void => {
  EditorActor.send({ type: EventType.RequestClose });
};

export const openEditor = (
  memoId: MemoId,
  mode: EditorMode,
  closingBehavior: ClosingBehaviour,
  canToggleMode: boolean,
): void => {
  EditorActor.send({
    type: EventType.RequestOpen,
    memoId,
    mode,
    closingBehavior,
    canToggleMode,
  });
};

export const setEditorMode = (mode: EditorMode): void => {
  EditorActor.send({ type: EventType.RequestSetMode, mode });
};
